export function UpdateCreditorGroup(this: any) {
  return {
    id: this.id,
    groupName: this.groupName,
    displayName: this.description,
    activeStatus: true,
    description: this.description,
    templateGroupId: this.templateGroupId
  };
}